  (function () {

    /* -----------------------------
      LOGIN DETECTION (LIVE)
    ----------------------------- */
    function isLoggedIn() {
      if (typeof window.customerData !== 'undefined' && window.customerData !== null) {
        return true;
      }
      return document.cookie.indexOf('secure_customer_sig') !== -1;
    }

    /* -----------------------------
      BLOCK LOGIN POPUP IF LOGGED IN
    ----------------------------- */
    function blockLoginPopup() {
      var checkInterval = setInterval(function() {
        if (window.AuthModalManager && window.AuthModalManager.show) {
          clearInterval(checkInterval);

          var originalShow = window.AuthModalManager.show;

          window.AuthModalManager.show = function () {
            if (isLoggedIn()) {
              console.log('Login popup blocked (already logged in)');
              return;
            }
            originalShow.apply(this, arguments);
          };
        }
      }, 100);

      setTimeout(function() {
        clearInterval(checkInterval);
      }, 5000);
    }

    /* -----------------------------
      WISHLIST MANAGER
    ----------------------------- */
    if (typeof window.WishlistManager === 'undefined') {

      window.WishlistManager = {
        storageKey: 'customWishlist',

        getWishlist: function () {
          if (!isLoggedIn()) return [];
          try {
            var wishlist = localStorage.getItem(this.storageKey);
            return wishlist ? JSON.parse(wishlist) : [];
          } catch (e) {
            console.error('Error reading wishlist:', e);
            return [];
          }
        },

        saveWishlist: function (wishlist) {
          if (!isLoggedIn()) return false;
          try {
            localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
            this.updateCount();
            return true;
          } catch (e) {
            console.error('Error saving wishlist:', e);
            return false;
          }
        },

        addItem: function (item) {
          if (!isLoggedIn()) return false;
          var wishlist = this.getWishlist();
          if (!wishlist.some(i => i.id === item.id)) {
            wishlist.push({
              id: item.id,
              handle: item.handle,
              title: item.title,
              url: item.url,
              image: item.image,
              price: item.price || null,
              type: item.type || 'collection',
              addedAt: new Date().toISOString()
            });
            this.saveWishlist(wishlist);
            return true;
          }
          return false;
        },

        removeItem: function (itemId) {
          if (!isLoggedIn()) return false;
          var wishlist = this.getWishlist();
          var newWishlist = wishlist.filter(i => i.id !== itemId);
          this.saveWishlist(newWishlist);
          return true;
        },

        isInWishlist: function (itemId) {
          if (!isLoggedIn()) return false;
          return this.getWishlist().some(i => i.id === itemId);
        },

        toggleItem: function (item) {
          if (!isLoggedIn()) return null;
          if (this.isInWishlist(item.id)) {
            this.removeItem(item.id);
            return false;
          } else {
            this.addItem(item);
            return true;
          }
        },

        updateCount: function () {
          if (!isLoggedIn()) return;
          var wishlist = this.getWishlist();
          var countElement = document.getElementById('wishlistCount');
          if (countElement) {
            countElement.textContent = wishlist.length;
            countElement.classList.toggle('hidden', wishlist.length === 0);
          }
        },

        initializeButtons: function () {
          var wishlistButtons = document.querySelectorAll('.wysh-button');

          for (var i = 0; i < wishlistButtons.length; i++) {
            var button = wishlistButtons[i];
            if (button.dataset.wishlistInitialized) continue;
            button.dataset.wishlistInitialized = 'true';

            var itemId = button.getAttribute('data-collection-id') || button.getAttribute('data-product-id');
            if (this.isInWishlist(itemId)) button.classList.add('added');

            var self = this;
            button.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (!isLoggedIn()) {
                console.log('User not logged in, showing auth modal');
                if (window.AuthModalManager) window.AuthModalManager.show();
                return;
              }

              var btn = this;
              var itemData = {
                id: btn.getAttribute('data-collection-id') || btn.getAttribute('data-product-id'),
                handle: btn.getAttribute('data-collection-handle') || btn.getAttribute('data-product-handle'),
                title: btn.getAttribute('data-collection-title') || btn.getAttribute('data-product-title'),
                url: btn.getAttribute('data-collection-url') || btn.getAttribute('data-product-url'),
                image: btn.getAttribute('data-collection-image') || btn.getAttribute('data-product-image'),
                price: btn.getAttribute('data-item-price') || btn.getAttribute('data-product-price') || null,
                type: btn.getAttribute('data-item-type') || (btn.getAttribute('data-product-id') ? 'product' : 'collection')
              };

              btn.classList.add('loading');

              setTimeout(function () {
                var isAdded = self.toggleItem(itemData);
                btn.classList.remove('loading');
                btn.classList.toggle('added', isAdded);
              }, 300);

            });
          }
        }
      };

      /* -----------------------------
        INIT AFTER DOM READY
      ----------------------------- */
      function initWishlist() {
        console.log('Initializing wishlist, logged in:', isLoggedIn());
        blockLoginPopup();
        window.WishlistManager.initializeButtons();
        window.WishlistManager.updateCount();

        /* -----------------------------
          PASS CREATOR ID TO COLLECTION LINKS
        ----------------------------- */
        (function () {
          var creatorElement = document.getElementById('creatorData');
          if (!creatorElement) return;

          var creatorId = creatorElement.getAttribute('data-creator-id');
          if (!creatorId) return;

          document.addEventListener('click', function (e) {
            var link = e.target.closest('.creator-collection-link');
            if (!link) return;

            e.preventDefault();

            try {
              var url = new URL(link.href, window.location.origin);
              url.searchParams.set('creator_id', creatorId);
              window.location.href = url.toString();
            } catch (err) {
              console.error('Error appending creator_id:', err);
              window.location.href = link.href + '?creator_id=' + creatorId;
            }
          });
        })();

        /* -----------------------------
          PASS CREATOR ID TO PRODUCT LINKS
        ----------------------------- */
      (function () {

        var params = new URLSearchParams(window.location.search);
        var creatorId = params.get('creator_id');

        if (!creatorId) return; // nothing to pass forward

        document.addEventListener('click', function (e) {

          var link = e.target.closest('a[href*="/products/"]');
          if (!link) return;

          // prevent double processing
          if (link.dataset.creatorHandled === 'true') return;

          var url = new URL(link.href, window.location.origin);

          // if already present, do nothing (prevents loop)
          if (url.searchParams.get('creator_id') === creatorId) return;

          e.preventDefault();

          url.searchParams.set('creator_id', creatorId);

          link.dataset.creatorHandled = 'true';

          window.location.href = url.toString();

        });

      })();

      /* -----------------------------
        FORCE ADD CREATOR ID TO CART
      ----------------------------- */
     (function () {

      function getCreatorId() {
        return new URLSearchParams(window.location.search).get('creator_id');
      }

      document.addEventListener('submit', function (e) {
        var form = e.target;

        if (!form.matches('form[action*="/cart/add"]')) return;

        var creatorId = getCreatorId();
        if (!creatorId) return;

        // Prevent default form submit so we can use AJAX
        e.preventDefault();

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = formData.get('quantity') || 1;

        var properties = {};
        formData.forEach(function(value, key) {
          if (key.startsWith('properties[')) {
            var propKey = key.match(/^properties\[(.*)\]$/)[1];
            properties[propKey] = value;
          }
        });

        // AJAX request to add item + cart attribute
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: parseInt(quantity, 10),
                properties: properties
              }
            ],
            attributes: {
              "_creator_id": creatorId
            }
          })
        })
        .then(res => res.json())
        .then(cart => {
          console.log('Cart updated:', cart);
          window.location.href = '/cart'; // optional redirect
        })
        .catch(err => console.error(err));

      }, true);

    })();

        // Safe MutationObserver initialization
        if (document.body) {
          var observer = new MutationObserver(function () {
            window.WishlistManager.initializeButtons();
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWishlist);
      } else {
        initWishlist();
      }

    }

  })();